import { createClient } from '@supabase/supabase-js';
import type { Database } from '@core/types/database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    `Missing Supabase environment variables (VITE_SUPABASE_URL=${supabaseUrl ?? 'undefined'}, VITE_SUPABASE_ANON_KEY=${supabaseAnonKey ? '[set]' : 'undefined'}). ` +
    'Ensure these are configured in Cloudflare Pages → Settings → Environment variables and that a new deployment has been triggered after adding them.'
  );
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
  },
  global: {
    headers: {
      'x-client-info': 'merino-crm',
    },
  },
});

// Export typed helpers
export type SupabaseClient = typeof supabase;

